import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import ExercisesList from "./exercise_list/ExercisesList";
import { useParams } from "react-router-dom";

import style from "./SectionsPage.css"

const SectionsPage = () => {

    const [sectionsList, setSectionsList] = useState([]);
    const [activeSection, setActiveSection] = useState('');
    const [activeExercise, setActiveExercise] = useState('');
    let params = useParams();
    var title = params.title;
    var subTitle = params.subTitle;
    
    /* Fetch the data once here */
    const jsonData = require(`../../data/${title}/${subTitle}.json`);

    // TODO: Fetch data from data base
    const fetchSections = () => {
        // const jsonData = require(`../../data/${title}/${subTitle}.json`);
        const keys = Object.keys(jsonData[subTitle]);
    
        // Using the functional form of setSectionsList
        setSectionsList(sectionsList => [...sectionsList, ...keys]);
        // console.log("This is the sections list: " + sectionsList);
        // console.log("element 0 " + sectionsList[0]);
    }

    // TODO: Fetch exercises form the data base insteade of fetching them locally.
    const fetchExercisesOfSection = (section) => {
        // const jsonData = require(`../../data/${title}/${subTitle}.json`);
        const fetchedExercisesList = jsonData[subTitle][section];
        return fetchedExercisesList
    }

    const getMiddleElementId = () => {
        // const windowHeight = window.innerHeight;
        const middleY = window.innerHeight / 2
        // const windowScrollReference = windowHeight / 4; // Scroll reference
        let closestDistance = 500;
        let middleElementId = null;
      
        const elements = document.querySelectorAll('div.section');
        // const elements = document.querySelectorAll('div.exercise-panel');
      
        /* Go through all the dics elements with className equal to section and check which is the closest to 
         * to windowScrollReference */
        elements.forEach(element => {
            if (element) {
                const rect = element.getBoundingClientRect();

                // Check if the element is fully visible
                // if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                if(true) {
                    const distanceToMiddle = Math.abs(rect.top + rect.height / 2 - middleY); /* = rectangle_side / 2 - middleY = rectangle_middle - middleY*/

                // const elementPosition = element.getBoundingClientRect().top;
                // const distanceToMiddle = Math.abs(elementPosition - windowScrollReference);
        
                if (distanceToMiddle < closestDistance) {
                    closestDistance = distanceToMiddle;
                    middleElementId = element.id;  // exercise-panel id = section_name + exercise_id
                    }
                }
            }
        });
      
        return middleElementId;
    }

    const handleScroll = () => {
        const currentSection = getMiddleElementId();
        setActiveSection(currentSection);
        // setActiveExercise(getMiddleElementId());
    };

    const writeSectionNameAsTitle = (sectionName) => {
        let sectionNameAsTitle = sectionName.replaceAll('_', ' ');
        sectionNameAsTitle = sectionNameAsTitle.toUpperCase();
        return sectionNameAsTitle;
    };

    useEffect(() => {
        fetchSections();
        setActiveSection(sectionsList[0]);
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    return (
        <div className="sections-container">

            <div className="summary-container">
                <div className="summary">
                    <div className="content-container">
                        <div className="content-title"> Content </div>
                        <div class="horizontal-line"></div>
                    </div>
                    {sectionsList  && sectionsList.map((sectionName, index) => (
                    <div key={index} className={`summary-item ${activeSection === "section-" + sectionName ? 'active' : ''}`}>
                    {/* <div key={index} className="summary-item"> */}
                        <div key={index} className="summary-item-sectionName">
                            <p>{writeSectionNameAsTitle(sectionName)}</p>
                        </div>
                        <div className={`summary-exercises-list ${activeSection === "section-" + sectionName ? 'active' : ''}`}>
                        {fetchExercisesOfSection(sectionName).map((exerciseObj, index) => (
                            // <div className={`summary-item ${activeExercise === section + '-' + exerciseObj.id ? 'active' : ''}`}>
                            <div key={index} className={exerciseObj.id}>
                                Exercise {exerciseObj.id}
                            </div>
                        ))}
                        </div>
                    </div>
                    ))}
                </div>
            </div>

            <div className="sections">
                {sectionsList  && sectionsList.map((sectionName, index) => (
                <div key={index} className = "section" id={"section-" + sectionName}>
                    <ExercisesList subTitle={subTitle} sectionName={sectionName} exercisesList={fetchExercisesOfSection(sectionName)}/>
                </div>
                ))}
            </div>
        </div>
    );
}

export default SectionsPage;
